<template>
<div class="box-labourParticulars">
    <div class="nav">
        <router-link to="AdministrativeHome"><img src="../../assets/up.png" alt="" class="upClass"></router-link>
        资料申请
        <img src="../../assets/search.png" alt="" class="searchClass" @click="getOnPage">
    </div>
    <div class="swiper-container">
        <div class="swiper-wrapper">
            <div class="swiper-slide">
                <div class="labourParticulars">
                    <h4 class="labourParticulars-title labourParticulars-title-active">学校相关资质使用申请流程</h4>
                    <p>1. 注意事项</p>
                    <span class="spanClass labourParticulars-title-content-active">学校相关资质包括天津新东方总公司及各校区分公司营业执照（营业执照、组织机构代码证和税务登记证三证合一）、办学许可证、开户行许可证等。在因公代表公司签订合同、申请办理个人签证、申请办理个人落户等合理情况下，可以进行申请。学校相关资质文件十分重要，请各位老师严格按照申请用途规范使用。</span>
                    <img src="../../assets/xiaNoPage.png" alt="" class="labourParticulars_bottomImg">
                </div>
            </div>
            <div class="swiper-slide">
                <div class="labourParticulars">
                    <h4 class="labourParticulars-title labourParticulars-title-active">学校相关资质使用申请流程</h4>
                    <p>2. 申请流程</p>
                    <span class="spanClass labourParticulars-title-content-active">使用个人企业邮发送邮件进行申请，其正文应包括申请人、申请文件（纸质版/电子版）、使用用途等相关内容。将申请邮件依次发送至主管上级、部门总监、校办总监刘胜洪（liushenghong）进行审批，待全部审批完成后，转发至校办代博（daibo3）、高帆（gaofan14），纸质版请前往中粮广场17层校办高帆处领取。</span>
                </div>
            </div>
        </div>
    </div>

</div>
</template>

<script>
import Swiper from "swiper";
import "swiper/dist/css/swiper.min.css";
export default {
    data() {
        return {
            fingerprintShow: false,
            flowShow: false,
            agreementShow: false
        };
    },
    methods: {
        fn() {
            
        },
        getOnPage(){
            this.$router.push({name: 'Search', params:{code:"1004"}})
        },
    },
    mounted() {
        this.fn();
        var mySwiper = new Swiper(".swiper-container", {
            direction: "vertical" // 垂直切换选项
            // loop: true // 循环模式选项
        });
    }
};
</script>

<style>
.swiper-container {
    width: 100%;
    height: 100%;
}

.box-labourParticulars {
    width: 100%;
    height: 100%;
    background: rgba(244, 244, 244, 1);
    overflow: hidden;
}

.upClass,
.searchClass {
    position: absolute;
    top: 0;
    bottom: 0;
    margin: auto;
}

.nav {
    width: 100%;
    height: 50px;
    background: #11a093;
    text-align: center;
    line-height: 50px;
    color: #ffffff;
    position: relative;
    margin-bottom: 17px;
}

.upClass {
    width: 12px;
    float: left;
    left: 10px;
}

.searchClass {
    width: 19px;
    float: right;
    right: 10px;
}

.labourParticulars {
    width: 90%;
    height: 83%;
    margin: 0 auto;
    background: rgba(255, 255, 255, 1);
    box-shadow: 0px 3px 12px 0px rgba(136, 135, 135, 0.5);
    border-radius: 11px;
    padding-top: 5%;
    position: relative;
}

.labourParticulars .labourParticulars-title {
    text-align: center;
    font-weight: 600;
}

.labourParticulars .labourParticulars-hw {
    margin-bottom: 20px;
}

.labourParticulars p {
    color: #696969;
    font-size: 16px;
    margin: 25px 16px 0;
}

.labourParticulars span {
    display: block;
    line-height: 30px;
    margin-left: 16px;
    margin-right: 16px;
    color: #888787;
    font-size: 14px;
}

.labourParticulars .spanClass {
    text-indent: 30px;
}

.labourParticulars_bottomImg {
    width: 15%;
    display: block;
    left: 0;
    right: 0;
    margin: auto;
    position: absolute;
    bottom: 12px;
}

.QRcode {
    width: 30%;
    display: block;
    margin: 10px auto;
}
.labourParticulars-title-active {
    font-size: 16px
}
.labourParticulars-title-content-active {
    letter-spacing:2px;
    line-height: 30px;
}
</style>



// WEBPACK FOOTER //
// src/components/Administrative/administrative1.vue